export const KROOLO_APP_STORE_URL =
  "https://apps.apple.com/in/app/kroolo/id6740263578";

export const KROOLO_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.kroolo.app";
